import React, { useEffect, useContext } from 'react';
import { useQuery } from 'react-query';
import { Toolbar } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import * as _ from 'lodash';
import { CgDetailsMore } from 'react-icons/all';
import { TraitService } from 'services';
import { TraitsCtx } from 'pages/TraitsPage';
import AppLoader from '../../basic/AppLoader';
import CollectionItemHeader from '../../layout/CollectionItemHeader';
import getTheme from '../../../theme/theme';
import BasicField from '../../basic/BasicField';
import TemplateUpload from './traits-report-template/TemplateUpload';
import TextCorpus from './traits-text-corpus/TextCorpus';
import TraitReportDemoPreview from './traits-report-demo-preview/TraitReportDemoPreview';

function TraitsDetails(props) {
  const {
    traits,
    setTraits,
  } = useContext(TraitsCtx);

  const onTraitPropertyChange = (key, val) => {
    setTraits({ ...traits, [key]: val });
  };

  const { isLoading, data, isError } = useQuery([ 'traits', props.id ],
    () => {
      return TraitService.getById(props.id);
    });

  useEffect(
    () => {
      setTraits((prevTrait) => {
        if (_.isEqual(data, prevTrait)) {
          return prevTrait;
        }
        return data;
      });
    }, [ data, setTraits ],
  );
  if (isLoading) {
    return <AppLoader />;
  }
  if (!traits) {
    return <AppLoader />;
  }
  if (isError) {
    return <div>Trait Not found</div>;
  }
  const traitBasicDetails = [
    { field: 'name', label: 'Name', disabled: true },
    { field: 'category', label: 'Category', disabled: true },
  ];

  return (
    <>
      <CollectionItemHeader
        title={ `ID ${ data.id }` }
        subtitle={ `Name: ${ data.name }` }
        actions={ (
          <>
          </>
        ) }
      />
      <Toolbar />
      <Grid container spacing={ 3 }>
        <Grid item xs={ 12 } md={ 8 }>
          <Grid item>
            <div style={ { display: 'flex', flexDirection: 'column', alignItems: 'leading', justifyContent: 'space-between', marginBottom: getTheme().spacing(2) } }>
              <div style={ { display: 'flex', alignItems: 'center', flexDirection: 'row' } }>
                <CgDetailsMore style={ { marginRight: getTheme().spacing(2) } } size={ 24 } />
                <Typography variant='h6'>
                  Trait Details
                </Typography>
              </div>
              <Card>
                <Grid container spacing={ 3 }>
                  <Grid item xs={ 12 } md={ 12 }>
                    <CardContent>
                      {
                        traitBasicDetails.map(({ field, label, disabled }) => {
                          return (
                            <BasicField
                              key={ field }
                              onChange={
                                (v) => {
                                  return onTraitPropertyChange(field, v);
                                }
                              }
                              disabled={ disabled }
                              title={ label }
                              field={ traits[field] }
                            />
                          );
                        })
                      }
                    </CardContent>
                  </Grid>
                </Grid>
              </Card>
            </div>
          </Grid>
          <Grid item>
            <div style={ { display: 'flex', flexDirection: 'column', alignItems: 'leading', justifyContent: 'space-between', marginBottom: getTheme().spacing(2) } }>
              <div style={ { display: 'flex', alignItems: 'center', flexDirection: 'row' } }>
                <CgDetailsMore style={ { marginRight: getTheme().spacing(2) } } size={ 24 } />
                <Typography variant='h6'>
                  Report template
                </Typography>
              </div>
              <Card>
                <Grid container spacing={ 3 }>
                  <Grid item xs={ 12 } md={ 12 }>
                    <CardContent>
                      <TemplateUpload trait={ data } />
                    </CardContent>
                  </Grid>
                </Grid>
              </Card>
            </div>
          </Grid>
          <Grid item>
            <div style={ { display: 'flex', flexDirection: 'column', alignItems: 'leading', justifyContent: 'space-between', marginBottom: getTheme().spacing(2) } }>
              <div style={ { display: 'flex', alignItems: 'center', flexDirection: 'row' } }>
                <CgDetailsMore style={ { marginRight: getTheme().spacing(2) } } size={ 24 } />
                <Typography variant='h6'>
                  Text corpus
                </Typography>
              </div>
              <Card>
                <Grid container spacing={ 3 }>
                  <Grid item xs={ 12 } md={ 12 }>
                    <CardContent>
                      <TextCorpus trait={ data } />
                    </CardContent>
                  </Grid>
                </Grid>
              </Card>
            </div>
          </Grid>
          <Grid item>
            <div style={ { display: 'flex', flexDirection: 'column', alignItems: 'leading', justifyContent: 'space-between', marginBottom: getTheme().spacing(2) } }>
              <div style={ { display: 'flex', alignItems: 'center', flexDirection: 'row' } }>
                <CgDetailsMore style={ { marginRight: getTheme().spacing(2) } } size={ 24 } />
                <Typography variant='h6'>
                  Report demo preview
                </Typography>
              </div>
              <Card>
                <Grid container spacing={ 3 }>
                  <Grid item xs={ 12 } md={ 12 }>
                    <CardContent>
                      <TraitReportDemoPreview trait={ data } />
                    </CardContent>
                  </Grid>
                </Grid>
              </Card>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
export default TraitsDetails;
